import React from 'react';

/**
 * ErrorBoundary captura errores de renderizado en componentes hijos
 * y muestra una UI amigable en vez de una pantalla blanca.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturó un error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '2.5rem',
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            maxWidth: '480px',
            width: '100%'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
              &#9888;
            </div>
            <h2 style={{
              color: '#1e3a8a',
              marginBottom: '0.75rem',
              fontSize: '1.25rem'
            }}>
              Algo salió mal
            </h2>
            <p style={{
              color: '#64748b',
              marginBottom: '1.5rem',
              fontSize: '0.9rem',
              lineHeight: '1.5'
            }}>
              Ocurrió un error inesperado. Por favor intente recargar la página o volver al inicio.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                onClick={this.handleReload}
                style={{
                  padding: '0.6rem 1.2rem',
                  background: 'linear-gradient(to right, #1e3a8a, #3b82f6)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  fontWeight: '500'
                }}
              >
                Recargar página
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '0.6rem 1.2rem',
                  background: '#f1f5f9',
                  color: '#475569',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  fontWeight: '500'
                }}
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
